import { RollupStatus } from "./types";

export type { RollupStatus } from "./types";

export const OPEN_STATUSES: readonly string[] = ["Open", "Assigned"];
export const WIP_STATUSES: readonly string[] = [
  "Work In Progress",
  "Researching",
  "Pending",
];
export const RESOLVED_STATUSES: readonly string[] = ["Resolved", "Closed"];

/**
 * Raw Tickety statuses the wire request sends when Open_Only_Toggle is on:
 * every status whose Rollup_Status is not `resolved`.
 */
export const OPEN_ONLY_WIRE_STATUSES: readonly string[] = [
  ...OPEN_STATUSES,
  ...WIP_STATUSES,
];

const RAW_TO_ROLLUP: Readonly<Record<string, RollupStatus>> = {
  Open: "open",
  Assigned: "open",
  "Work In Progress": "work-in-progress",
  Researching: "work-in-progress",
  Pending: "work-in-progress",
  Resolved: "resolved",
  Closed: "resolved",
};

export function rollupStatusOf(rawStatus: string): RollupStatus {
  const mapped = RAW_TO_ROLLUP[rawStatus];
  return mapped !== undefined ? mapped : "open";
}
